import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("opscmd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("opscmd_token");
      localStorage.removeItem("opscmd_user");
    }
    return Promise.reject(err);
  }
);

export function fileUrl(fileId) {
  const token = localStorage.getItem("opscmd_token");
  return `${API}/files/${fileId}?auth=${encodeURIComponent(token || "")}`;
}
